import { ListingData, useListingData } from "~/context/ListingPageDataContext";

import { useFsvDepositLayout } from "../../hooks/use-fsv-deposit-layout";

import { FsvPaymentSchedule } from "./FsvPaymentSchedule";
import type { FsvPaymentScheduleSectionProps } from "./FsvPaymentSchedule.types";

/**
 * Connects `FsvPaymentSchedule` to deposit pricing so the fee-calc card and
 * form can render the same schedule without duplicating the wiring.
 */
export const FsvPaymentScheduleSection = ({
  className,
  headingId,
}: FsvPaymentScheduleSectionProps) => {
  const { data: listingData = {} as ListingData } = useListingData();
  const { depositBreakdown, foodDrinkCategoryPhrase, showDepositLayout } =
    useFsvDepositLayout();

  if (!showDepositLayout || !depositBreakdown) return null;

  return (
    <FsvPaymentSchedule
      className={className}
      currency={listingData.listingCurrency}
      dueAtVenue={depositBreakdown.dueAtVenue}
      dueToday={depositBreakdown.dueToday}
      foodDrinkCategoryPhrase={foodDrinkCategoryPhrase}
      headingId={headingId}
      minSpend={depositBreakdown.minSpend}
      spaceRental={depositBreakdown.spaceRental}
    />
  );
};
